<app-view-item
  *ngIf="disabled"
  [text]="displayText"
  [borderless]="borderless"
></app-view-item>

<nz-select
  *ngIf="!disabled"
  [(ngModel)]="value"
  nzShowSearch
  (ngModelChange)="onModelChange($event)"
  nzAllowClear="true"
  [nzDropdownMatchSelectWidth]="false"
  [required]="isRequired"
>
  <nz-option
    [nzValue]="item.longCode"
    [nzLabel]="item.name"
    *ngFor="let item of options"
    nzCustomContent
  >
    <div class="dropdown-container">
      {{ item.name }}
    </div>
  </nz-option>
</nz-select>
